import React, { FC } from 'react'
import cns from 'classnames'
import { Link } from 'react-router-dom'
import Avatar from './Avatar'
import Dialog from './Dialog'
import BtnIcon from './BtnIcon'
import Card from './Card'
import { ReactSVG } from 'react-svg'
import { Participant } from '../server/utils/getArticlesData'

interface Props {
  className?: string
  title?: string
  items: Participant[]
  count: number
  link?: () => React.ReactNode
}

const MAX_PARTICIPANTS_COUNT = 6

const Participants: FC<Props> = ({
  className = '',
  title = 'Участники',
  items,
  count,
  link
}) => {
  return (
    <div className={cns('participants', {'_empty': count === 0}, className)}>
      <div className={'participants__head'}>
        {title && (<p className="participants__title">{title}</p>)}
        {!!link && (
          <>
            {link()}
          </>
        )}
      </div>
      {(items?.length > 0)
        ? (
          <div className="participants__list">
            {items?.slice(0, MAX_PARTICIPANTS_COUNT).map((item, index) => (
              <Link to={`/participant/${item.id}`} key={index}>
                <Avatar size="sm" url={item.avatar} />
              </Link>
            ))}
            {count > MAX_PARTICIPANTS_COUNT && (
              <Dialog
                activator={(open) => (
                  <BtnIcon
                    className="participants__more"
                    primary={true}
                    onClick={async () => await open()}
                  >{`+${count - MAX_PARTICIPANTS_COUNT}`}</BtnIcon>
                )}
                render={(close) => (
                  <Card style={{ maxWidth: '55rem' }}>
                    <header className="card-head _centered">
                      <div className="card-head__title text-h3">Участники</div>

                      <BtnIcon
                        className={'card-head__control _right-side'}
                        onClick={async () => await close()}
                        filled
                      >
                        <ReactSVG src={'/i/svg/x.svg'} wrapper={'span'}></ReactSVG>
                      </BtnIcon>
                    </header>

                    <ul className="participants__list-popup">
                      {items?.map((item, index) => (
                        <li className="participants__list-popup-item" key={index}>
                          <Avatar size="sm" url={item.avatar} />
                          <Link
                            className={'participants__name text-body-bold'}
                            to={`/participant/${item.id}`}
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </Card>
                )}
              />
            )}
          </div>
        )
        : (
          <BtnIcon
            className="participants__more"
            primary={true}
          >
            0
          </BtnIcon>
        )
      }
    </div>
  )
}

export default Participants
